<template>
  <v-toolbar-items>
    <v-btn
      v-for="(item, index) in isNotAuthenticatedLargeMenu"
      :key="index"
      text
      class="fetch"
      :to="item.link"
    >
      {{ item.title }}
    </v-btn>
  </v-toolbar-items>
</template>

<script>
export default {
  // data () {
  //   return {
  //     isNotAuthenticatedLargeMenu: [
  //       // Common path's
  //       // { title: 'Home', link: '/' },
  //       // NotAuth path's
  //       // { title: 'Login', link: '/login' },
  //       { title: 'Signup', link: '/signup' }
  //     ]
  //   }
  // }
  computed: {
    isNotAuthenticatedLargeMenu () {
      return [
        // Common path's
        // { title: 'Home', link: '/' },
        // NotAuth path's
        // { title: 'Login', link: '/login' },
        { title: this.$t('nav.isNotAuthenticated.item-1'), link: '/signup' }
      ]
    }
  }
}
</script>
